module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Export":"Exporter en Excel","Title":"Rapport des activités d\u0027analyse prévente","PreSaleAnalysisActivities":"Activités d\u0027analyse prévente","ForOpportunitiesWithStatus":"pour les opportunités ayant un statut"}}')
  delete Component.options._Ctor
}
